<template>
    <div class="">
        <div class="form-group">
            <label>Titel des Blocks</label>
            <input type="text" class="form-control" v-model="config.title" placeholder="Lager">
        </div>

        <div class="form-group">
            <label>Sell Out Mwst. herausrechnen</label>
            <select class="form-control" v-model="config.sellOutRemoveTax">
                <option :value="false">Nein</option>
                <option :value="true">Ja</option>
            </select>
        </div>

        <fieldset class="border px-3 mb-3">
            <legend class="w-auto">
                <i class="fas fa-info-circle text-muted"
                   style=""
                   data-toggle="tooltip"
                   data-placement="top"
                   :title="$info['lager.stockMode']"></i>
                Bestandsfilter
            </legend>

            <div class="form-group">
                <label><b>Modus</b></label>
                <select class="form-control" v-model="config.stockMode">
                    <option value="none">Deaktiviert</option>
                    <option value="between">Lagerbestand zwischen</option>
                </select>
            </div>

            <div class="row" v-if="config.stockMode === 'between'">
                <div class="col">
                    <div class="form-group">
                        <label>Min</label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">Stück</span>
                            </div>
                            <input type="text" class="form-control" placeholder="0" v-model="config.stockMin">
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="form-group">
                        <label>Max</label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">Stück</span>
                            </div>
                            <input type="text" class="form-control" placeholder="0" v-model="config.stockMax">
                        </div>
                    </div>
                </div>
            </div>

        </fieldset>

        <fieldset class="border px-3 mb-3">
            <legend class="w-auto">
                <i class="fas fa-info-circle text-muted"
                   style=""
                   data-toggle="tooltip"
                   data-placement="top"
                   :title="$info['lager.verfallMode']"></i>
                Haltbarkeit
            </legend>

            <div class="form-group">
                <label><b>Modus</b></label>
                <select class="form-control" v-model="config.verfallMode">
                    <option value="all">Alle</option>
                    <option value="between">Frühester Verfall zwischen</option>
                </select>
            </div>

            <div class="row" v-if="config.verfallMode === 'between'">
                <div class="col">
                    <div class="form-group">
                        <label>Ab</label>
                        <div class="row">
                            <div class="col">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">Monat</span>
                                    </div>
                                    <input type="number" class="form-control" placeholder="01" v-model="config.verfallStartMonth">
                                </div>
                            </div>
                            <div class="col">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">Jahr</span>
                                    </div>
                                    <input type="number" class="form-control" placeholder="2022" v-model="config.verfallStartYear">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="form-group">
                        <label>Bis</label>
                        <div class="row">
                            <div class="col">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">Monat</span>
                                    </div>
                                    <input type="number" class="form-control" placeholder="12" v-model="config.verfallEndMonth">
                                </div>
                            </div>
                            <div class="col">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">Jahr</span>
                                    </div>
                                    <input type="number" class="form-control" placeholder="2022" v-model="config.verfallEndYear">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </fieldset>

        <fieldset class="border px-3 mb-3">
            <legend class="w-auto">
                <i class="fas fa-info-circle text-muted"
                   style=""
                   data-toggle="tooltip"
                   data-placement="top"
                   :title="$info['lager.anLagerMode']"></i>
                Produkt an Lager
            </legend>

            <div class="form-group">
                <label><b>Modus</b></label>
                <select class="form-control" v-model="config.anLagerMode">
                    <option value="all">Alle</option>
                    <option value="yes">An Lager: Ja</option>
                    <option value="no">An Lager: Nein</option>
                </select>
            </div>

        </fieldset>

        <div class="form-group mb-0" v-if="selectableVisibleColumns.length">
            <label>Sichtbare Spalten:</label>
            <div class="form-check form-check-inline" v-for="column in selectableVisibleColumns">
                <input class="form-check-input"
                       type="checkbox"
                       :id="id(column.id)"
                       :value="column.id"
                       :checked="!config.hiddenColumns.includes(column.id)"
                       @change="toggleHiddenColumns(column.id, $event)">
                <label class="form-check-label" :for="id(column.id)">
                    {{ column.label }}
                </label>
            </div>
        </div>
    </div>
</template>

<script>
import blockMixin from "./blockMixin";

export default {
    components: {},
    mixins: [blockMixin],
    props: {

    },
    data() {
        return {
            config: this.dto
        };
    },
    methods: {
        toggleHiddenColumns(columnId, event) {
            if (event.target.checked) {
                this.config.hiddenColumns = this.config.hiddenColumns.filter(id => id !== columnId);
            } else {
                this.config.hiddenColumns.push(columnId);
            }
        }
    },
    computed: {
        selectableVisibleColumns() {
            return [
                {id: 'sell-in', label: 'Sell In'},
                {id: 'sell-out', label: 'Sell Out'},
            ];
        },
    }
}
</script>
